var _g, _g2, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgVision(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 68,
    height: 68,
    viewBox: "0 0 68 68",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_1660_5550)"
  }, /*#__PURE__*/React.createElement("rect", {
    x: 8,
    y: 8,
    width: 52,
    height: 52,
    rx: 8,
    fill: "white"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1660_5550)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M34.0523 29.5475C31.591 29.5475 29.5974 31.5412 29.5974 34.0024C29.5974 36.4637 31.591 38.4574 34.0523 38.4574C36.5136 38.4574 38.5072 36.4637 38.5072 34.0024C38.5011 31.5412 36.5074 29.5475 34.0523 29.5475ZM34.0523 32.5503C33.2524 32.5503 32.6001 33.2025 32.6001 34.0024C32.6001 34.3716 32.3048 34.667 31.9356 34.667C31.5664 34.667 31.271 34.3716 31.271 34.0024C31.271 32.4703 32.5201 31.2212 34.0523 31.2212C34.4215 31.2212 34.7168 31.5165 34.7168 31.8857C34.7168 32.2549 34.4153 32.5503 34.0523 32.5503Z",
    fill: "#1EAFDC"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M48.6169 32.9995C34.7845 17.0873 22.2812 29.6829 19.303 33.1718C18.9031 33.6394 18.8969 34.3286 19.2969 34.7962C32.9509 50.733 45.3496 38.7712 48.6169 35.0239C49.1277 34.4455 49.1277 33.584 48.6169 32.9995ZM34.0523 40.328C30.5573 40.328 27.7268 37.4975 27.7268 34.0025C27.7268 30.5074 30.5573 27.6769 34.0523 27.6769C37.5473 27.6769 40.3778 30.5074 40.3778 34.0025C40.3778 37.4975 37.5412 40.328 34.0523 40.328Z",
    fill: "#1EAFDC"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_1660_5550",
    x: 0,
    y: 0,
    width: 68,
    height: 68,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", null), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.15 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_1660_5550"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_1660_5550",
    result: "shape"
  })), /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1660_5550"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 30,
    height: 30,
    fill: "white",
    transform: "translate(19 19)"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgVision);
export default __webpack_public_path__ + "static/media/vision.f86d9e938235a4f0aa485d2ea2a0bf35.svg";
export { ForwardRef as ReactComponent };